import * as React from "react"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Form from "@bappweb/form"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import { required ,numeric} from "@bappweb/utils"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Page from "@components/globalmodules/page"
import BigLogoAkbank from "@components/globalmodules/logo/index-bigLogo"
import "./style.scss"
import { CaptchaCallService } from "@config/axios/captchaCallService"
/*import { ResetPasswordService } from "@config/axios/resetPasswordService"*/
import { useHistory } from "react-router-dom"
/*import { CaptchaVerifyService } from "@config/axios/captchaVerifyService"
import { UserInfoService } from "@config/axios/userInfoService"
import { SendSMSService } from "@config/axios/sendSMSService"*/
import { CompositeResetPassword } from "@config/axios/compositeResetPassword"
import { email as checkEmail } from "@bappweb/utils"



let responseData: { retCode: number, retMsg: string } = {
  
  retCode: 99,
  retMsg: ""
}

/*let captchaVerifyRespData: { result: string, resultCode: number, resultMessage: string } = {
  result: "",
  resultCode: 0,
  resultMessage: ""
}

let userInfoRespData: { retPhone: string, retCode: string, retMsg: string } = {
  retPhone: "",
  retCode: "",
  retMsg: ""
}*/
const SftpForgotPassword = () => {
  const [serviceReturnCode, setServiceRetCode] = useState("");
  const [serviceReturnMsg, setServiceRetMsg] = useState("");
  const [base64Image, setbase64Image] = React.useState("");
  const [captchaResp, setCaptchaResp] = useState({ id: "" });

  const { t } = useTranslation()
  const size = useDeviceSize()
  const history = useHistory()


  useEffect(() => {
    //#region Captcha Call
    const fetchData = async () => {
      const data = await CaptchaCallService();
      setCaptchaResp(data);
      ConvertBase64ToImage(data);
    }

    fetchData();

    //#endregion

  }, []);

  const handleSubmit = React.useCallback(async (e, data) => {

    //#region Captcha Verify
    responseData = await CompositeResetPassword({ id: captchaResp.id, entry: data.securityCode,userId: data.userName, mail: data.mail , phone:data.phone});
    //#endregion
    if (responseData.retCode === 0 ) {
      const passData = { userName: data.userName ,mail:data.mail,phone:data.phone  };
      history.push('/sftp-forgotPassword-msg', { passData });
      //#region Reset Psw
     /* retPsw = await ResetPasswordService({ username: data.userName });*/
      //#endregion
    /*  if (retPsw !== "") {

        //#region Get User Phone
        userInfoRespData = await UserInfoService({ userName: data.userName });
        //#endregion
        if ((userInfoRespData.retCode).toString() === "0") {
          //#region Send SMS
          responseData = await SendSMSService({ username: data.userName, gsmNo: userInfoRespData.retPhone, newPsw: retPsw });
          setServiceRetMsg(responseData.retAnaReferans)

          if (parseInt(responseData.retAnaReferans) !== 0 && responseData.retAnaReferans !== "") {
           
            const passData = { userName: data.userName, gsmNo: userInfoRespData.retPhone, newPsw: retPsw };
            history.push('/sftp-forgotPassword-msg', { passData });

          }
          else {
            setServiceRetCode(responseData.retCode);
            setServiceRetMsg(t("Error sending SMS"));
          }

          //#endregion
        }
        else {
          setServiceRetMsg(t("Kullanıcı Adı tanımlı değil !"));
        }
      }*/
    }
    else {
      setServiceRetCode(responseData.retCode.toString())
      setServiceRetMsg(responseData.retMsg);
    }


  }, [history, captchaResp, t])

  const handleError = React.useCallback((e, errors) => {
    console.info(JSON.stringify(errors, void 0, 2))
  }, [])


  const handleReloadCaptchaClick = React.useCallback(async () => {

    const data = await CaptchaCallService();
    setCaptchaResp(data);
    ConvertBase64ToImage(data);

  }, [])

  function ConvertBase64ToImage(respData) {
    setbase64Image(respData.base64Contents);
  }


  const main = useMemo(() => {
    return (

      <Block className="bapp-page-login-main">
        <Block className="bapp-page-login-main-wrapper">
          <Element type="h1" style={{ fontSize: "24px", fontFamily: "Campton", textAlign: "center", fontWeight: "550" }}>{t("Forgot Password")}</Element>
          <Element className="sftp-header" style={{ fontSize: "14px", fontFamily: "Campton", textAlign: "center", fontWeight: "475", lineHeight: "20px" }} >{t("Your new password will be sent to your phone number which registered in the system")}</Element>

          <Form onSubmit={handleSubmit} onError={handleError} grid={false}>
            <TextField
              label={t("KULLANICI ADI")}
              placeholder={t("Kullanıcı Adın")}
              type="text"
              name="userName"
              validations={[
                required(t("validation.required")),

              ]}
            />
              <TextField
              label={t("E-POSTA")}
              placeholder={t("E-Postan")}
              type="text"
              name="mail"
              validations={[
                required(t("validation.required")),
                checkEmail(t("validation.checkEmail"))
              ]}
            />
              <TextField
              label={t("TELEFON")}
              placeholder={t("Telefon Numaran")}
              type="text"
              name="phone"
              maxLength={15}
              validations={[
                required(t("validation.required")),
                numeric(t("validation.numeric"))  
              ]}
            />
            <div style={{ display: "flex" }}>
              <TextField
                label={t("GÜVENLİK KODU")}
                placeholder={t("Güvenlik Kodun")}
                type="text"
                name="securityCode"
                validations={[required(t("validation.required"))]}
              />
              <span style={{ width: "30%", paddingTop: "13%" }}>
                <img src={"data:image/png;base64," + base64Image} width={"80%"} alt="" />
              </span>
              <span style={{ width: "10%", paddingTop: "13%" }}>
                <img src="../img/reload_icon.png" alt="logo" height={"40%"} onClick={handleReloadCaptchaClick} />
              </span>
            </div>
            <Button text={t("Reset Password")} type="submit" fullWidth />

          </Form>


          {
            serviceReturnCode !== '0' ? <p style={{ color: "#c81c27" }}><b>{serviceReturnMsg}</b></p> : ""
          }

        </Block>
      </Block >
    )
  }, [handleError, handleSubmit, t, base64Image, handleReloadCaptchaClick, serviceReturnCode, serviceReturnMsg])

  return (
    <Page className="bapp-page-login" container={false} footer={false}>
      {size !== Sizes.xs ? (
        <>
          <Block className="" />
          <Block className="bapp-page-login-desktop-wrapper bapp-container">
            <Block>
              <BigLogoAkbank />

              <Image path={"/img/svg/unlock-woman.svg"} fallbackText={t("Oriented Woman")} />
              <Element className="sftp-header" style={{ fontSize: "34px", color: "black" }} type="h2" >{t("Your files are safe with the file sharing center")}</Element>
              <Element style={{ fontSize: "23px", color: "black" }}>{t("Akbank güvenli dosya transferi ile FTP dosyalarını güvenli bir şekilde aktarabilirsiniz.")} </Element>
            </Block>
            {main}
          </Block>
        </>
      ) : (
        main
      )}
    </Page>
  )
}

export default SftpForgotPassword
